import {
    apiRequest,
    mappingBknList,
    mappingBknActive,
    mappingBknInactive,
} from "../../../../../services/adapters/kepegawaian/mappingBknService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", mappingBknList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", mappingBknInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", mappingBknActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository